'use client';

import {
  FRED_API_TERMS_URL,
  FRED_REQUIRED_NOTICE,
  FRED_WEB_URL,
} from './fredCompliance';

type FredAttributionProps = {
  className?: string;
  /** Shorter block for ROI / price contexts; still includes the exact required notice. */
  compact?: boolean;
};

/** FRED API attribution — https://fred.stlouisfed.org/docs/api/terms_of_use.html */
export function FredAttribution({ className, compact = false }: FredAttributionProps) {
  return (
    <div className={className ?? 'fred-attribution'}>
      <p className="fred-required-notice">{FRED_REQUIRED_NOTICE}</p>
      {!compact && (
        <p className="fred-attribution__detail">
          Reference metal prices are derived from U.S. Bureau of Labor Statistics import price indexes
          accessed via the{' '}
          <a href={FRED_WEB_URL} rel="noopener noreferrer" target="_blank">
            FRED®
          </a>{' '}
          API. Values are approximate and for hobbyist ROI only — not investment or trading advice.{' '}
          <a href={FRED_API_TERMS_URL} rel="noopener noreferrer" target="_blank">
            FRED API Terms of Use
          </a>
        </p>
      )}
    </div>
  );
}
